import React from 'react'
import { CookiesProvider } from 'react-cookie'
import Modals from '../../contexts/modals'
import ScrollToTop from './ScrollToTop'
// import DataApis from "../../apis/data_apis"

const AppWrapper = props => {
  return (

    <CookiesProvider>
      <ScrollToTop>
        <Modals>
          {props.children}
        </Modals>
      </ScrollToTop>
    </CookiesProvider>
  )
}

export default AppWrapper
